var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-drawer',{attrs:{"menus":_vm.menus,"allow-mini":false,"clipped":false,"dark":false,"floating":true,"color":"transparent","app":false}})}
var staticRenderFns = []

export { render, staticRenderFns }